export enum GalleryType {
  Single = "single",
  Carousel = "carousel",
  Gallery = "gallery",
}
